// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"31b95e19","455":"0bbf84da"}[chunkId] + ".chunk.js";
};